// TODO: group filters -> add types during rework and check all with group filters
import { IFiltersOptions, IGroupFilters } from '@/bundles/GroupFilters/helpers';
import { Nullable } from '@/utils/types';

const getFilterByType = (state) => (type): IGroupFilters => state[type]?.filters || {};
const getOptionsByType = (state) => (type): IFiltersOptions => state[type]?.options || {};
const getKeywordByType = (state) => (type): Nullable<string> => state[type]?.keyword;
const getFilterName = (state) => (type) => state[type]?.filterName;
const getFilterId = (state) => (type) => state[type]?.filterId || '';
const getLastSelectedType = (state) => (type) => state[type]?.lastSelectedType;
const getSavedSetId = (state) => (type): string => state[type]?.savedSetId || '';

export default {
  getFilterByType,
  getKeywordByType,
  getFilterName,
  getFilterId,
  getLastSelectedType,
  getSavedSetId,
  getOptionsByType
}
